import PostListItem from "./post-list-item";

export default PostListItem;